import { FieldWrapper } from '../FieldWrapper';
import { BaseFieldProps, getFieldStyles } from '../BaseField';

interface TextareaFieldProps extends BaseFieldProps {
  rows?: number;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const TextareaField = (props: TextareaFieldProps) => {
  const {
    className,
    label,
    placeholder,
    error,
    showError = false,
    rows = 4,
    name,
    labelClassName,
    value,
    onChange,
    disabled,
    readOnly,
    ...rest
  } = props;

  return (
    <FieldWrapper
      label={label}
      error={error}
      showError={showError}
      fieldId={name}
      labelClassName={labelClassName}
    >
      <textarea
        id={name}
        name={name}
        className={`${getFieldStyles(error, className, disabled, readOnly)} min-h-[48px]`}
        aria-invalid={showError && error ? true : undefined}
        aria-describedby={showError && error ? `${name}-error` : undefined}
        placeholder={placeholder}
        rows={rows}
        value={value}
        onChange={onChange}
        disabled={disabled}
        readOnly={readOnly}
        {...rest}
      />
    </FieldWrapper>
  );
};
